var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 7.48611C27.0434 7.90817 26.0153 8.19242 24.9363 8.32055C26.0381 7.66484 26.8842 6.62582 27.2818 5.38761C26.2515 5.99487 25.1097 6.43632 23.8942 6.67427C22.9224 5.64387 21.5347 5 20.0007 5C16.5567 5 14.0261 8.1935 14.8039 11.5087C10.372 11.2879 6.44167 9.1776 3.81025 5.97011C2.41275 8.35285 3.0855 11.4699 5.46017 13.0483C4.587 13.0204 3.76367 12.7824 3.04542 12.3851C2.98692 14.8411 4.75817 17.1387 7.3235 17.6502C6.57275 17.8526 5.7505 17.9 4.91417 17.7406C5.59233 19.8466 7.56183 21.3788 9.8975 21.4219C7.655 23.1693 4.82967 23.95 2 23.6183C4.36058 25.1225 7.16533 26 10.177 26C20.0808 26 25.6763 17.6868 25.3382 10.2306C26.3804 9.48231 27.285 8.54881 28 7.48611Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.68950654.svg";
export { ForwardRef as ReactComponent };